<template>
    <div id="classMap" class="section-map w-full h-full"></div>
</template>

<script>
export default {
    name: 'SectionMap',
};
</script>

<script setup>
const {$config} = useNuxtApp();

const {initClasses} = useStoreClasses();

const {home} = storeToRefs(useStoreMap());
const {getInitPosition, setLastPosition} = useStoreMap();

onMounted(async () => {
    const leaflet = usePluginLeaflet();
    await leaflet.init();
    const {$L} = useNuxtApp();

    await Promise.all([initClasses(), getInitPosition()]).then((values) => {
        const initPosition = values[1];
        const map = buildMap(initPosition);
        // console.log('Leaflet instance', map);
    });

    function buildMap({lat, lng, zoom}) {
        const {filterClasses} = storeToRefs(useStoreClasses());
        const map = $L.map('classMap', {
            center: [lat, lng],
            zoom: zoom,
            minZoom: 3,
        });
        $L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
            layerType: 'base',
            name: 'OpenStreetMap',
        }).addTo(map);
        filterClasses.value.forEach((item) => {
            let icon = new $L.DivIcon({
                className: 'my-div-icon',
                html: `<img src="${$config.public.images}map-marker.png" alt />
                            <span class="mt-1 hidden group-[.is-zoomed-in]:inline-block bg-white/90 border border-zinc-400 hover:border-zinc-600 rounded-full px-2 text-base
                                text-black font-medium overflow-x-visible whitespace-nowrap">${item.name}</span>`,
            });
            $L.marker([item.lat, item.lng], {icon})
                .addTo(map)
                .on('click', () => {
                    openPin(item.slug);
                });
        });
        $L.Control.Home = $L.Control.extend({
            options: {
                position: 'topleft',
            },
            onAdd: function (map) {
                const container = $L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                const button = $L.DomUtil.create('a', 'leaflet-control-button cursor-pointer', container);
                const span = $L.DomUtil.create('span', '', button);
                span.innerHTML = '📍';
                $L.DomEvent.disableClickPropagation(button);
                $L.DomEvent.on(button, 'click', function () {
                    goHome(map);
                });
                container.title = 'Go Home';
                return container;
            },
            onRemove: function (map) {},
        });
        const control = new $L.Control.Home();
        control.addTo(map);
        map.on('move', () => mapMoved(map));
        return map;
    }

    let debounce = null;
    function mapMoved(map) {
        if (debounce) clearTimeout(debounce);
        debounce = setTimeout(() => {
            let position = {
                lat: map.getCenter().lat,
                lng: map.getCenter().lng,
                zoom: map.getZoom(),
            };
            // console.log('Map moved', position);
            setLastPosition(position);
        }, 250);
    }

    function goHome(map) {
        map.panTo([home.value.lat, home.value.lng]);
        map.setZoom(home.value.zoom);
    }

    function openPin(slug) {
        const $router = useRouter();
        $router.push('/classes/' + slug);
    }
});
</script>
